import { Inject, Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { SiteBrowserService } from '../../core/util/site-browser.service';
var SiteTreetableService = (function () {
    function SiteTreetableService(siteBrowserService) {
        this.siteBrowserService = siteBrowserService;
        this.siteBrowserService = siteBrowserService;
    }
    /**
     * Returns the assets under a site/host
     * @param siteName
     * @returns {Observable<R>}
     */
    SiteTreetableService.prototype.getAssetsUnderSite = function (siteName) {
        var _this = this;
        var lazyFiles;
        return this.siteBrowserService.getTreeableAssetsUnderSite(siteName)
            .map(function (treeables) { return _this.extractDataFilter(treeables); });
    };
    /**
     * Returns the assets under a folder
     * @param siteName
     * @param uri
     * @returns {Observable<R>}
     */
    SiteTreetableService.prototype.getAssetsUnderFolder = function (siteName, uri) {
        var _this = this;
        var lazyFiles;
        return this.siteBrowserService.getTreeableAssetsUnderFolder(siteName, uri)
            .map(function (treeables) { return _this.extractDataFilter(treeables); });
    };
    SiteTreetableService.prototype.extractDataFilter = function (treeables) {
        var assets = [];
        for (var i = 0; i < treeables.length; i++) {
            var treeable = treeables[i];
            var leaf = true;
            if (treeable.type === 'folder') {
                leaf = false;
            }
            else if (treeable.type === 'file_asset') {
                treeable.type = 'file';
            }
            var treeNode = {
                data: treeable,
                leaf: leaf
            };
            // console.log(treeable);
            assets[i] = treeNode;
        }
        return assets;
    };
    return SiteTreetableService;
}());
export { SiteTreetableService };
SiteTreetableService.decorators = [
    { type: Injectable },
    { type: Inject, args: ['siteBrowserService',] },
];
/** @nocollapse */
SiteTreetableService.ctorParameters = function () { return [
    { type: SiteBrowserService, },
]; };
//# sourceMappingURL=site-treetable.service.js.map